import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import { MerchantBasicDataViewModel } from '@app/api/marketplace/models';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { MerchantBasicDataFormComponent } from '@merchant/components/merchant-basic-data/merchant-basic-data-form/merchant-basic-data-form.component';
import {
  MerchantActions,
  MerchantSelectors,
} from '@merchant/store/merchant.slice';
import { CanComponentDeactivate } from '@shared/guards/can-deactivate.guard';
import { ApiErrorResponse } from '@shared/interfaces/api-error-response';
import { DialogService } from '@shared/services/dialog.service';

@Component({
  selector: 'app-partner-basic-data',
  templateUrl: './partner-basic-data.component.html',
  styleUrls: ['./partner-basic-data.component.scss'],
})
export class PartnerBasicDataComponent implements OnInit, OnDestroy {
  @ViewChild(MerchantBasicDataFormComponent)
  merchantBasicDataForm!: MerchantBasicDataFormComponent;

  isLoading$: Observable<boolean> = this.store.select(
    MerchantSelectors.isBasicDataLoading
  );

  isLoaded$: Observable<boolean> = this.store.select(
    MerchantSelectors.isBasicDataLoaded
  );
  hasLoadError$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectBasicDataLoadError
  );
  data$: Observable<MerchantBasicDataViewModel | undefined> = this.store.select(
    MerchantSelectors.selectBasicData
  );

  isUpdating$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectBasicDataUpdating
  );
  updateError$: Observable<ApiErrorResponse | undefined> = this.store.select(
    MerchantSelectors.selectBasicDataUpdateError
  );

  logoUrl$: Observable<string | undefined> = this.store.select(
    MerchantSelectors.selectMerchantLogoUrl
  );

  isLogoUpdating$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectMerchantLogoUpdating
  );

  logoUpdateError$: Observable<ApiErrorResponse | undefined> =
    this.store.select(MerchantSelectors.selectMerchantLogoUpdateError);

  private subs = new SubSink();

  constructor(private readonly store: Store, private router: Router) {}

  ngOnInit(): void {
    this.subs.sink = this.store
      .select(AuthenticationSelectors.selectMerchantId)
      .subscribe((merchantId) => {
        if (!merchantId) {
          this.router.navigate(['/telesales/partner-registration'], {
            replaceUrl: true,
          });
        }
      });
  }
  onSubmit(data: { formValue: any; firstLogin: boolean }) {
    this.store.dispatch(
      MerchantActions.updateBasicDataByTelesales.trigger({
        data: data.formValue,
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
